import { Navbar } from "src/app/services/models/enums";

export const SIDEBAR_LOGOUT_OPTION = 'logout';

export type ActiveNavbarOptions =
  Navbar.dashboard  |
  Navbar.dashboardCL |
  Navbar.dashboardCR |
  Navbar.opcionesCL |
  Navbar.carteras |
  Navbar.personas |
  Navbar.favoritos |
  Navbar.buscar |
  Navbar.orderTrackingProcessedFiles |
  Navbar.preguntasFrecuentes;

export type SidebarOrderOption = ActiveNavbarOptions | typeof SIDEBAR_LOGOUT_OPTION;

type orderByNavbarOption = {
  [key in SidebarOrderOption]: number;
}

const orderByNavbarOption: orderByNavbarOption = {
  [Navbar.dashboard]: 0,
  [Navbar.dashboardCL]: 0,
  [Navbar.dashboardCR]: 0,
  [Navbar.opcionesCL]: 0,
  [Navbar.carteras]: 1,
  [Navbar.personas]: 2,
  [Navbar.favoritos]: 3,
  [Navbar.buscar]: 4,
  [Navbar.orderTrackingProcessedFiles]: 5,
  [Navbar.preguntasFrecuentes]: 6,
  [SIDEBAR_LOGOUT_OPTION]: 7,
};

export function getOrderByNavbarOption(option: SidebarOrderOption) {
  return orderByNavbarOption[option];
}
